import _classCallCheck from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { _optionalChain } from '@sentry/utils/esm/buildPolyfills';
import { logger, isThenable } from '@sentry/utils';
import { shouldDisableAutoInstrumentation } from './utils/node-utils.js';
function isValidPrismaClient(possibleClient) {
  return possibleClient && !!possibleClient['$use'];
}

/** Tracing integration for @prisma/client package */
var Prisma = /*#__PURE__*/function () {
  /**
   * Prisma ORM Client Instance
   */

  /**
   * @inheritDoc
   */
  function Prisma() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Prisma);
    ;
    Prisma.prototype.__init.call(this);
    if (isValidPrismaClient(options.client)) {
      this._client = options.client;
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn("Unsupported Prisma client provided to PrismaIntegration. Provided client: ".concat(JSON.stringify(options.client)));
    }
  }

  /**
   * @inheritDoc
   */
  _createClass(Prisma, [{
    key: "__init",
    value:
    /**
     * @inheritDoc
     */
    function __init() {
      this.name = Prisma.id;
    }
  }, {
    key: "setupOnce",
    value: function setupOnce(_, getCurrentHub) {
      if (!this._client) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('PrismaIntegration is missing a Prisma Client Instance');
        return;
      }
      if (shouldDisableAutoInstrumentation(getCurrentHub)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('Prisma Integration is skipped because of instrumenter configuration.');
        return;
      }
      this._client.$use(function (params, next) {
        var scope = getCurrentHub().getScope();
        var parentSpan = _optionalChain([scope, 'optionalAccess', function (_2) {
          return _2.getSpan;
        }, 'call', function (_3) {
          return _3();
        }]);
        var action = params.action;
        var model = params.model;
        var span = _optionalChain([parentSpan, 'optionalAccess', function (_4) {
          return _4.startChild;
        }, 'call', function (_5) {
          return _5({
            description: model ? "".concat(model, " ").concat(action) : action,
            op: 'db.sql.prisma'
          });
        }]);
        var rv = next(params);
        if (isThenable(rv)) {
          return rv.then(function (res) {
            _optionalChain([span, 'optionalAccess', function (_6) {
              return _6.finish;
            }, 'call', function (_7) {
              return _7();
            }]);
            return res;
          });
        }
        _optionalChain([span, 'optionalAccess', function (_8) {
          return _8.finish;
        }, 'call', function (_9) {
          return _9();
        }]);
        return rv;
      });
    }
  }], [{
    key: "__initStatic",
    value:
    /**
     * @inheritDoc
     */
    function __initStatic() {
      this.id = 'Prisma';
    }
  }]);
  return Prisma;
}();
Prisma.__initStatic();
export { Prisma };